import { ArrowDownward } from "@mui/icons-material";
import { TableContainer, CircularProgress } from "@mui/material";

import CustomIconButton from "../../../ui library/components/buttons/CustomIconButton";
import HNSColors from "../../../ui library/HNSColors";

import ContactsTable from "./ContactsTable";
import NoDataContainer from "./NoDataContainer";

export default function ContactsTableSection({
  visibleData,
  fieldOptions,
  contactTypeColors,
  permissions,
  editHandler,
  deleteHandler,
  loading,
  showMore,
  loadMore,
  maxHeight = true,
}) {
  if (visibleData && visibleData.length === 0) {
    return <NoDataContainer />;
  }
  return (
    <TableContainer
      sx={{
        ...(maxHeight && { maxHeight: "90vh", overflowY: "auto" }),
        overflowY: "auto",
        "&::-webkit-scrollbar": { width: "8px" },
        "&::-webkit-scrollbar-track": {
          backgroundColor: HNSColors.primary[900],
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: HNSColors.primary[600],
        },
      }}
    >
      <ContactsTable
        data={visibleData}
        fieldOptions={fieldOptions}
        contactTypeColors={contactTypeColors}
        permissions={permissions}
        editHandler={editHandler}
        deleteHandler={deleteHandler}
      />
      {loading && (
        <div className="py-4 text-center">
          <CircularProgress color="secondary" />
        </div>
      )}
      {showMore && (
        <CustomIconButton
          classes="p-2"
          iconVisible={true}
          CustomIcon={<ArrowDownward />}
          handleOnClick={loadMore}
        />
      )}
    </TableContainer>
  );
}
